import { useEffect, useRef, useState } from "react";
import { Input } from "../../components/ui/input";
import { ItemTexto } from "./Itens";
import { cleoApi } from "./api";

const PAUSA_PADRAO = "Opa, vi que um atendente humano começou o atendimento! Cleo pausada por [TEMPO] minutos. 🤖➡️👤";

/**
 * Pausa por atendente e mensagem de entretenimento — as duas moram em
 * /api/chatbot/bot-settings. Um estado só, salvo sozinho ~1 s depois da
 * última mudança. `parte` escolhe qual cartão desenhar.
 */
export function useBotSettings({ onStatus, toast }) {
  const [bot, setBot] = useState(null);
  const timer = useRef(null);
  useEffect(() => {
    cleoApi.botSettings().then((d) => d?.success && setBot(d)).catch(() => {});
    return () => clearTimeout(timer.current);
  }, []);
  const mudar = (parcial) => {
    setBot((b) => ({ ...b, ...parcial }));
    clearTimeout(timer.current);
    timer.current = setTimeout(async () => {
      onStatus?.("salvando");
      try {
        const r = await cleoApi.salvarBotSettings(parcial);
        if (!r?.success) throw new Error(r?.error || r?.detail || "Não foi possível salvar.");
        onStatus?.("salvo");
      } catch (e) {
        onStatus?.("");
        toast?.({ title: "Erro ao salvar", description: e.message, variant: "destructive" });
      }
    }, 900);
  };
  return [bot, mudar];
}

export function PausaAtendente({ bot, mudar, onVerPrevia }) {
  if (!bot) return null;
  return (
    <ItemTexto semChave ligado label="Aviso de pausa"
      hint="Sai quando alguém da equipe responde pelo celular: a CLEO para de responder aquele cliente pelo tempo escolhido. [TEMPO] vira os minutos."
      texto={bot.bot_pause_message} onTexto={(t) => mudar({ bot_pause_message: t })} padrao={PAUSA_PADRAO}
      onVerPrevia={() => onVerPrevia({ titulo: "Aviso de pausa", texto: (bot.bot_pause_message || "").replace(/\[TEMPO\]/gi, String(bot.bot_pause_duration || 15)) })}
      extras={(
        <label className="flex items-center gap-2 text-xs text-muted-foreground">
          A CLEO fica pausada por
          <Input type="number" min={1} max={1440} value={bot.bot_pause_duration ?? 15}
            onChange={(e) => mudar({ bot_pause_duration: Math.max(1, parseInt(e.target.value, 10) || 15) })}
            className="h-7 w-20 text-center text-xs font-semibold tabular-nums" />
          minutos
        </label>
      )} />
  );
}

export function Entretenimento({ bot, mudar, onVerPrevia }) {
  if (!bot) return null;
  return (
    <ItemTexto label="Entretenimento enquanto espera"
      hint="Sai depois do aviso 'Em produção', com o link do joguinho da loja."
      ligado={!!bot.arcade_message_enabled} onLigar={(v) => mudar({ arcade_message_enabled: v })}
      texto={bot.arcade_message_text} onTexto={(t) => mudar({ arcade_message_text: t })}
      onVerPrevia={() => onVerPrevia({ titulo: "Entretenimento", prefixo: true, texto: bot.arcade_message_text })}
      extras={(
        <label className="flex items-center gap-2 text-xs text-muted-foreground">
          Enviar depois de
          <Input type="number" min={0} max={3600} value={bot.arcade_message_delay ?? 40}
            onChange={(e) => mudar({ arcade_message_delay: Math.max(0, parseInt(e.target.value, 10) || 0) })}
            className="h-7 w-20 text-center text-xs font-semibold tabular-nums" />
          segundos
        </label>
      )} />
  );
}
